import { makeVar, useReactiveVar } from "@apollo/client";
const isMiniAppVar = makeVar(false);
const isInMiniAppVar = makeVar(false);
const isInitializedVar = makeVar(false);
export const useMiniApp = () => {
    const isMiniApp = useReactiveVar(isMiniAppVar);
    const isInMiniApp = useReactiveVar(isInMiniAppVar);
    const isInitialized = useReactiveVar(isInitializedVar);
    return {
        isInitialized,
        isMiniApp,
        isInMiniApp, // app can be loaded in mini app mode, but not actully in farcaster mini app container
    };
};
export const setMiniAppParams = ({ isMiniApp, isInMiniApp, }) => {
    isMiniAppVar(isMiniApp);
    isInMiniAppVar(isInMiniApp);
    isInitializedVar(true);
};
